import React, { useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import SearchSelect from './SearchSelect';

const TenantSelector = ({ show, tenants, onSelect }) => {
  const [selected, setSelected] = useState('');

  const options = (tenants || []).map((t) => ({ label: `${t.tenantId} — ${t.tenantName || t.tenantId}`, value: t.tenantId }));

  return (
    <Modal show={show} backdrop="static" keyboard={false} centered>
      <Modal.Header>
        <Modal.Title>Select Tenant</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>You have SYSADMIN access to multiple tenants. Please select one to continue:</p>
        <SearchSelect
          label="Tenant"
          name="tenantId"
          options={options}
          value={selected}
          onChange={(e) => setSelected(e.target.value)}
          required={true}
        />
      </Modal.Body>
      <Modal.Footer>
        <Button className="add-btn" onClick={() => selected && onSelect(selected)} disabled={!selected}>
          Continue
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default TenantSelector;
